import { DialogRequestProps } from "@hooks/useDialog/types";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@components/ui/alert-dialog";
import {
  Dialog,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogContent,
  DialogClose,
} from "@components/ui/dialog";
import { Button } from "@components/ui/button";
import { cn } from "@utils/index";

export interface DialogComponentProps {
  dialogInfo: DialogRequestProps | null;
  isDialogOpen: boolean;
  closeDialog: () => void;
  children?: React.ReactNode;
}

function DialogComponent({
  dialogInfo,
  isDialogOpen,
  closeDialog,
  children,
}: DialogComponentProps) {
  return (
    <Dialog
      open={
        isDialogOpen &&
        !(
          dialogInfo?.dialogType === "confirm" ||
          dialogInfo?.dialogType === "alert"
        )
      }
      onOpenChange={
        dialogInfo?.dialogType === "loading"
          ? undefined
          : (val) => {
            if (!val) {
              closeDialog();
            }
          }
      }
    >
      <AlertDialog
        open={
          isDialogOpen &&
          (dialogInfo?.dialogType === "confirm" ||
            dialogInfo?.dialogType === "alert")
        }
        onOpenChange={(val) => {
          if (!val) {
            closeDialog();
          }
        }}
      >
        {children}
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>{dialogInfo?.title}</AlertDialogTitle>
            {dialogInfo?.description && (
              <AlertDialogDescription>
                {dialogInfo?.description}
              </AlertDialogDescription>
            )}
          </AlertDialogHeader>
          {dialogInfo?.dialogType === "confirm" && (
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => {
                  dialogInfo?.onCancel?.();
                }}
              >
                {dialogInfo?.cancelText ?? "No"}
              </AlertDialogCancel>
              <AlertDialogAction
                onClick={() => {
                  dialogInfo?.onConfirm?.();
                }}
              >
                {dialogInfo?.confirmText ?? "Yes"}
              </AlertDialogAction>
            </AlertDialogFooter>
          )}
          {dialogInfo?.dialogType === "alert" && (
            <AlertDialogFooter>
              <AlertDialogCancel
                onClick={() => {
                  dialogInfo?.onCancel?.();
                }}
              >
                {"Okay"}
              </AlertDialogCancel>
            </AlertDialogFooter>
          )}
        </AlertDialogContent>
      </AlertDialog>

      <DialogContent
        className={cn(
          "pointer-events-none flex flex-col gap-2",
          dialogInfo?.disableBG ? "border-none" : "",
        )}
        hideCloseButton={dialogInfo?.disableBG || dialogInfo?.hideCloseButton}
        style={{
          maxWidth: dialogInfo?.maxWidth,
          height: dialogInfo?.height,
          backgroundColor: dialogInfo?.disableBG ? "transparent" : undefined,
          boxShadow: dialogInfo?.disableBG ? "none" : undefined,
        }}
      >
        <DialogHeader>
          {dialogInfo?.title && <DialogTitle>{dialogInfo?.title}</DialogTitle>}
          {dialogInfo?.description && (
            <DialogDescription>{dialogInfo?.description}</DialogDescription>
          )}
        </DialogHeader>
        {dialogInfo?.customContent}
        {dialogInfo?.showActions && (
          <DialogFooter>
            <DialogClose asChild>
              <Button type="button" variant="secondary">
                Close
              </Button>
            </DialogClose>
          </DialogFooter>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default DialogComponent;
